<template>
    <div class="container">
        <div class="content">
            <el-form :inline="true" :model="searchForm" ref="searchForm" class="search-form" size="small"
                label-width="64px">
                <el-form-item label="公告标题">
                    <!-- <el-autocomplete class="inline-input" v-model="searchForm.title" :fetch-suggestions="querySearch"
                        placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect"
                        clearable></el-autocomplete> -->
                    <el-input v-model="searchForm.title" placeholder="请输入" clearable show-word-limit
                        maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="关键字">
                    <!-- <el-autocomplete class="inline-input" v-model="searchForm.keyword" :fetch-suggestions="querySearch"
                        placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect"
                        clearable></el-autocomplete> -->
                    <el-input v-model="searchForm.keyword" placeholder="请输入" clearable show-word-limit
                        maxlength="30"></el-input>
                </el-form-item>
                <el-form-item label="分类">
                    <template #label>分<span class="space"></span>类</template>
                    <el-select v-model="searchForm.categoryId" placeholder="请输入或选择" clearable>
                        <el-option v-for="item in categoryList" :key="item.id" :label="item.categoryName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="创建时间">
                    <eldate @changeData="changeData($event, 'createdTime')" :dateData="createdTime"></eldate>
                </el-form-item>

                <!-- <el-form-item label="所属部门">
                    <el-cascader @change="handleSelectOrgId" v-model="searchForm.orgId1" :options="options" :show-all-levels="false" :props="{
                        checkStrictly: true,
                        label: 'orgName',
                        value: 'orgPath',
                        children: 'children',
                    }" clearable filterable></el-cascader>
                </el-form-item> -->
                <el-form-item label="发起人">
                    <el-autocomplete class="inline-input" v-model="searchForm.createdByName"
                        :fetch-suggestions="userSearch" placeholder="请输入内容" :trigger-on-focus="false"
                        @select="handleSelect1" clearable></el-autocomplete>
                </el-form-item>
                <el-form-item label="接收人">
                    <!-- <el-autocomplete class="inline-input" v-model="searchForm.createUserId"
                        :fetch-suggestions="querySearch1" placeholder="请输入内容" :trigger-on-focus="false"
                        @select="handleSelect1" clearable></el-autocomplete> -->
                    <el-select v-model="searchForm.receivers" placeholder="请选择接收人员" @click.native="openUserPicker"
                        class="select-u" collapse-tags size="medium" multiple popper-class="hidden">
                        <el-option v-for="(user, index) in searchForm.receivers" :key="index" :label="user.name"
                            :value="user">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审批状态">
                    <el-select v-if="dictionaries.notice_approval_status" v-model="searchForm.approvalStatus"
                        placeholder="请输入或选择" clearable filterable>
                        <el-option v-for="items in dictionaries.notice_approval_status" :key="items.dictId"
                            :label="items.dictName" :value="items.dictId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="公告状态">
                    <el-select v-if="dictionaries.notice_status" v-model="searchForm.noticeStatus" placeholder="请输入或选择"
                        clearable filterable>
                        <el-option v-for="items in dictionaries.notice_status" :key="items.dictId"
                            :label="items.dictName" :value="items.dictId"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="登录手机号">
                    <template #label>
                        <div class="custom-label">登录<br/>手机号</div>
                    </template>
<el-input v-model="searchForm.phoneNumber" placeholder="请输入登录手机号" clearable></el-input>
</el-form-item> -->
                <el-form-item label="发布时间">
                    <eldate @changeData="changeData($event, 'publishTime')" :dateData="publishTime"></eldate>
                </el-form-item>


                <el-form-item style="float: right;margin-right: 0px;">
                    <div style="display: flex;">
                        <div class="s-btn" @click="fetchData('search')">查询</div>
                        <div class="r-btn" @click="fetchData('reset')">重置</div>
                    </div>
                </el-form-item>
            </el-form>
            <div class="line"></div>
            <div class="data-title">
                <div style="display: flex;height: 32px;">
                    <div class="title-line"></div>
                    <div class="title-name">数据列表</div>
                </div>

                <div class="title-btn">
                    <div class="title-btn-item" @click="openDialog()">
                        <img src="@/assets/img/announcement/icon_fenlei.png" style="width: 16px;height: 16px;" />
                        <div class="btn-l">管理分类</div>
                    </div>
                    <div class="title-btn-item" @click="deliverData()">
                        <img src="@/assets/icon_daochu.png" style="width: 16px;height: 16px;" />
                        <div class="btn-l">导出列表</div>
                    </div>
                    <div class="title-btn-item" @click="add">
                        <i class="el-icon-plus"></i>
                        <div class="btn-l">新增公告内容</div>
                    </div>
                </div>
            </div>
            <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="totalNum"
                layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection"
                @size-change="handleSizeChange" @p-current-change="handleCurrentChange" class="left-aligned-table">
            </lb-table>
        </div>
        <!-- 查看员工浮层 -->
        <view-employment ref="viewEmployment"></view-employment>
        <category-manager :categories="initialCategories" @update="handleCategoriesUpdate"
            ref="CategoryManager"></category-manager>
        <!-- 审批详情弹窗 -->
        <pop-process ref="popProcess" />
        <org-picker title="接收人员" :multiple="true" ref="orgPicker" @ok="selectedUser" />
    </div>
</template>
<script>
import eldate from '@/components/eldate.vue'
import LbTable from '@/components/lb-table/lb-table'
import PopProcess from "@/pages/assetManagement/common/popProcess";
import viewEmployment from '@/components/viewEmployment'
import categoryManager from '@/pages/announcement/components/CategoryManager'
import OrgPicker from "@/components/OrgPicker";
export default {
    name: 'announcementList',
    components: {
        eldate,
        LbTable,
        viewEmployment,
        categoryManager,
        PopProcess,
        OrgPicker
    },
    data() {
        return {
            initialCategories: [ // 添加这个属性
                { id: 1, name: "公司公告" },
                { id: 2, name: "部门通知" },
                { id: 3, name: "系统消息" }
            ],
            showCalendar: true,
            statuss: [
                { dictId: 'A', dictName: '已转正' },
                { dictId: 'T', dictName: '试用' },
                { dictId: 'W', dictName: '待离职' }
            ],
            // employeeTime: [],
            createdTime: [],
            publishTime: [],
            searchForm: {
                platformType: null,
                sysUserId: null,
                pageNo: 1,
                pageSize: 10,
                title: '',
                content: '',
                categoryId: null,
                categoryName: '',
                keyword: '',
                createdBy: null,
                createdByName: '',
                createdTimeStart: '',
                createdTimeEnd: '',
                createUserName: '',
                createUserId: null,
                approvalStatus: null, // 审批状态 1-审核中 2-审核通过 3-撤销 4-驳回 5-待审批
                noticeStatus: null,
                publishTimeStart: '',
                publishTimeEnd: '',
                receivers: [],
                ids: [],
                processInstanceId: null // 审批流程实例ID
            },
            categoryList: {},
            form: {
                name: ''
            },
            page: {
                pageNo: 1,
                pageSize: 10
            },
            parArray: [],
            list: [],
            totalNum: 0,
            columns: [
                { type: 'selection', minWidth: '80' },
                {
                    label: '公告标题', prop: 'title', width: '129',

                    render: (h, scope) => {
                        return (
                            <div class='align-left' header-align="left" style="display: -webkit-box;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;-webkit-box-orient: vertical;">
                                {scope.row.title}
                            </div>
                        )
                    }
                },
                { label: '分类', prop: 'categoryName', width: '124' },
                { label: '创建时间', prop: 'createdTime', minWidth: '160' },
                { label: '发起人', prop: 'createdByName', minWidth: '160' },
                {
                    label: '更新时间', prop: 'updatedTime', minWidth: '160',
                },
                { label: '发布时间', prop: 'publishTime', minWidth: '160' },
                {
                    label: '接收人员', prop: 'receiver', width: '151',
                    render: (h, scope) => {
                        return (
                            <div class='ellipsis2' title={scope.row.receiver}>{scope.row.receiver ? scope.row.receiver : "-"}</div>
                        )
                    }
                },
                {
                    label: '审批状态', prop: 'approvalStatus', minWidth: '102',
                    render: (h, scope) => {
                        // const statusDict = this.dictionaries.notice_approval_status;
                        // const statusItem = statusDict.find(item => item.dictId == scope.row.approvalStatus);
                        // return h('div', statusItem ? statusItem.dictName : '-')
                        const { approvalStatus, approvalDict } = scope.row;
                        return (
                            <div class='align-left'>
                                <span class={`icon-act-status icon-act-status-${approvalStatus}`}></span>{approvalDict == '待审核' ? '' : approvalDict}
                            </div>
                        )
                    }
                },
                {
                    label: '公告状态', prop: 'noticeStatus', width: '100',
                    render: (h, scope) => {
                        const { noticeStatus, noticeDict } = scope.row;
                        return (
                            <div class='align-left'>
                                <span class={`icon-act-status icon-not-status-${noticeStatus}`}></span>{noticeDict}
                            </div>
                        )
                    }
                },
                {
                    label: '发送人数', prop: 'sendCount', width: '100',
                    render: (h, scope) => {
                        return (
                            <div class='align-center'>
                                {scope.row.sendCount ? scope.row.sendCount : '-'}
                            </div>
                        )
                    }
                },
                {
                    label: '已读人数', prop: 'readCount', minWidth: '100',
                    render: (h, scope) => {
                        return (
                            <div class='align-center'>
                                {scope.row.readCount ? scope.row.readCount : '-'}
                            </div>
                        )
                    }
                },
                {
                    label: '确认人数', prop: 'confirmCount', minWidth: '100',
                    render: (h, scope) => {
                        return (
                            <div class='align-center'>
                                {scope.row.confirmCount ? scope.row.confirmCount : '-'}
                            </div>
                        )
                    }
                },
                {
                    label: '未读人数', prop: 'unreadCount', minWidth: '100',
                    render: (h, scope) => {
                        return (
                            <div class='align-center'>
                                {scope.row.unreadCount ? scope.row.unreadCount : '-'}
                            </div>
                        )
                    }
                },
                {
                    label: '操作', prop: 'orgName', minWidth: '150', fixed: "right",
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:center">
                                {
                                    <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.editAnnouncement(scope.row) }} >查看/编辑</div>
                                }
                                {
                                    <div style="cursor:pointer">
                                        <el-dropdown onCommand={($event) => { this.command($event, scope.row) }} >
                                            <span class="el-dropdown-link" style="color:#00B498">
                                                更多<i class="el-icon-arrow-down el-icon--right"></i>
                                            </span>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item class="custom-item" command="export">导出名单</el-dropdown-item>
                                                <el-dropdown-item class="custom-item" command="edit">审批流程</el-dropdown-item>
                                                {String(scope.row.noticeStatus) === '3' && <el-dropdown-item class="custom-item" command="deleteDraft">删除草稿</el-dropdown-item>}
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </div>
                                }

                            </div >
                        )
                    }
                },
            ],


            arr1: [
                {}, {

                }
            ],
            dictionaries: { // 字典数据
                notice_status: [], // 公告状态
                notice_approval_status: [], // 公告审批状态
                notice_read_status: [], // 通知阅读状态
            },
            options: [],
            positionList: [],
            timeout: null,
            detail: {},
            roleDataList: [],

        }
    },
    created() {
        this.department()
        // 获取字典值
        for (const type in this.dictionaries) {
            console.log(type + '字典数据1111');
            
            this.getDictionaries(type)
        }
        this.fetchData()
        this.fetchCategories()
        console.log('当前权限列表:', this.parArray); // 添加这行查看权限列表
        // this.getStaffs()
        // 权限设定判断 normsCode
        this.limits = JSON.parse(sessionStorage.getItem("limit"))
        const params = this.limits.buttonTreeDto.find(
            (item) => item.menuCode === "announcementList"
        )
        console.log("当前权限列表:", params.buttonList);
        
        params.buttonList.forEach((item) => {
            this.parArray.push(item.code);
        })
        
    },
    mounted() {
        // 监听刷新事件
        this.$bus.$on('refreshAnnouncementList', this.refreshData);
    },
    beforeDestroy() {
        // 移除事件监听
        this.$bus.$off('refreshAnnouncementList', this.refreshData);
    },
    methods: {
        // 刷新数据方法
        refreshData() {
            console.log('收到刷新事件，重新获取数据');
            this.fetchData();
        },
        command(val, row) {
            if (val === 'deleteDraft') {
                this.$confirm('确定删除这条公告草稿吗？', '删除草稿', {type: 'warning'}).then(() =>
                    this.$api.announcementDeleteDraft({id: row.id}).then(res => {
                        if (res.code !== 0) throw new Error(res.msg || '删除失败');
                        this.$message.success('草稿已删除');
                        this.fetchData();
                    }).catch(err => this.$message.error(err.message || '删除失败'))
                ).catch(() => {});
            } else if (val == 'export') {
                this.exportReadList(row.id)
            } else if (val == 'edit') {
                this.showApprovalDetail(row)
            }
        },
        exportReadList(id) {
            this.$api.announcementReadExport({ id: id }).then(res => {
                if (res.code == 0) {
                    const link = document.createElement("a");
                    link.href = res.data;
                    link.download = "公告阅读名单.xls";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.$message.success('导出成功')
                } else {
                    this.$message.error(res.message || '导出失败')
                }
            }).catch(err => {
                console.log(err)
                this.$message.error('导出失败')
            })
        },
        fetchData(type) {
            if (type == 'reset') {
                this.searchForm = {
                    platformType: null,
                    sysUserId: null,
                    pageNo: 1,
                    pageSize: 10,
                    title: '',
                    content: '',
                    categoryId: null,
                    categoryName: '',
                    keyword: '',
                    createdBy: null,
                    createdByName: '',
                    createdTimeStart: '',
                    createdTimeEnd: '',
                    createUserName: '',
                    createUserId: null,
                    approvalStatus: null,
                    noticeStatus: null,
                    publishTimeStart: '',
                    publishTimeEnd: '',
                    receivers: [],
                    processInstanceId: null,
                }
                this.publishTime = []
                this.createdTime = []
                this.page.pageNo = 1;
            } else {
                if (this.publishTime && this.publishTime.length > 0) {
                    this.searchForm.publishTimeStart = this.publishTime[0]
                    this.searchForm.publishTimeEnd = this.publishTime[1]
                } else {
                    this.searchForm.publishTimeStart = ''
                    this.searchForm.publishTimeEnd = ''
                }
                if (this.createdTime && this.createdTime.length > 0) {
                    this.searchForm.createdTimeStart = this.createdTime[0]
                    this.searchForm.createdTimeEnd = this.createdTime[1]
                } else {
                    this.searchForm.createdTimeStart = ''
                    this.searchForm.createdTimeEnd = ''
                }
            }

            // 设置分页参数
            this.searchForm.pageNo = this.page.pageNo
            this.searchForm.pageSize = this.page.pageSize

            if (type == 'search') {
                this.searchForm.pageNo = 1
                this.page.pageNo = 1
            }
            const payload = {
                ...this.searchForm,
                receivers: (this.searchForm.receivers || []).map(item => ({ id: item.id, name: item.name, type: item.type }))
            }
            this.$api.announcementList(payload).then(res => {
                if (res.code == 0) {
                    this.list = res.data.list || [];
                    this.totalNum = res.data.totalNum || 0;
                    this.page.pageNo = res.data.pageNo || 1;
                } else {
                    this.$message.error(res.message || '获取公告列表失败');
                }
            }).catch(error => {
                console.error('获取公告列表失败:', error);
                this.$message.error('获取公告列表失败');
            });
        },
        changeData(val, type) {
            console.log(val)
            if (type == 'publishTime') {
                this.publishTime = val
            } else {
                this.createdTime = val
            }

        },
        // 显示审批详情
        showApprovalDetail(row) {
            if (!row.processInstanceId) {
                this.$message.warning('该公告没有审批流程信息');
                return;
            }

            // 调用审批详情组件
            this.$refs.popProcess.show(row.processInstanceId);

        },
        getStaffs() {
            this.axios
                .get('/oa/sys/employee/superior/' + this.searchForm.reallyName)
                .then((res) => {
                    console.log(res)
                    if (res.code == 0) {
                        this.staffs = res.data

                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        querySearch(queryString, cb) {
            this.axios
                .get('/oa/sys/employee/superior/' + this.searchForm.reallyName)
                .then((res) => {
                    console.log(res)
                    if (res.code == 0) {
                        res.data.forEach((item) => {
                            item.value = item.name
                        })
                        this.staffs = res.data
                        var staffs = this.staffs;
                        var results = queryString ? staffs : [];
                        // 调用 callback 返回建议列表的数据
                        clearTimeout(this.timeout);
                        this.timeout = setTimeout(() => {
                            cb(results);
                        }, 3000 * Math.random());
                        // cb(results);
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        handleSelect(item) {
            this.searchForm.reallyName = item.name

        },
        querySearch1(queryString, cb) {
            this.axios
                .get('/oa/sys/employee/superior/' + this.searchForm.directSuperior)
                .then((res) => {
                    console.log(res)
                    if (res.code == 0) {
                        res.data.forEach((item) => {
                            item.value = item.name
                        })

                        var results = queryString ? res.data : [];
                        // 调用 callback 返回建议列表的数据
                        clearTimeout(this.timeout);
                        this.timeout = setTimeout(() => {
                            cb(results);
                        }, 3000 * Math.random());
                        // cb(results);
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        handleSelect1(item) {
            this.searchForm.createdByName = item.name

        },
        handleSelectOrgId(e) {
            this.searchForm.orgId = e
        },
        // 部门选择列表
        department() {
            this.axios
                .post(
                    "/sys/v1/org/tree/select",
                    {
                        request: {
                            orgName: "",
                            orgType: "",
                        },
                        version: "",
                    },
                    {
                        headers: {
                            isLoading: false,
                        },
                    }
                )
                .then((res) => {
                    console.log(res);
                    if (res.code == 0) {
                        this.options = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        fmObjToArr(data) {
            let arr = []
            for (let key in data) {
                let tem = []
                for (let i in data[key]) {
                    let obj = {
                        dictId: i,
                        dictName: data[key][i]

                    }
                    tem.push(obj)
                }
                arr.push({
                    label: tem, // label 字段
                    value: key   // value字段
                })
            }
            console.log(arr)
            return arr
        },
        lookDetail(val) {
            this.$refs.viewEmployment.show(val.id)
        },
        add() {
            this.$router.push({ path: '/announcement/add' });
        },

        editAnnouncement(row) {
            const announcementId = row.id;
            this.$router.push({ path: '/announcement/detail', query: { isEdit: true, id: announcementId } });
        },
        deliverData() {

            if (this.searchForm.ids.length == 0) {
                this.$message.warning('请勾选导出的数据')
            } else {
                // exportParams.ids = this.searchForm.ids;
                // 导出时也仅传递接收人 id 和 name
                const exportPayload = {
                    ...this.searchForm,
                    receivers: (this.searchForm.receivers || []).map(item => ({ id: item.id, name: item.name }))
                }
                this.$api.announcementExport(exportPayload).then(res => {
                    if (res.code == 0) {
                        // this.downloadlink(res.data)
                        const link = document.createElement('a');
                        link.href = res.data;
                        link.download = '公告列表.xls';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        this.$message({
                            type: 'success',
                            message: '导出成功!'
                        })

                    }
                })
            }

        },
        fetchCategories() {
            this.$api.announcementCList().then(res => {
                if (res.code == 0) {
                    console.log(res, '获取分类');
                    this.categoryList = res.data.map(item => {
                        return {
                            id: item.id,
                            categoryName: item.categoryName,
                            editing: false,
                            tempName: "",
                        }
                    })
                }
            })
        },
        onMultipleSelection(val) {
            // if (val.length == this.page.pageSize) {
            //     this.searchForm.allFlag = 1
            // }
            if (val) {
                this.searchForm.ids = val.map((item) => {
                    return item.id
                })
            }

        },
        handleCurrentChange(e) {
            this.page.pageNo = e
            this.fetchData()
        },
        handleSizeChange(e) {
            this.page.pageSize = e
            this.fetchData()
        },
        // 添加处理分类更新的方法
        handleCategoriesUpdate(updatedCategories) {
            console.log("分类已更新:", updatedCategories);
            // 这里可以添加更新逻辑，如保存到数据库
        },
        openDialog() {
            // 通过 ref 调用子组件的 openDialog 方法
            this.$refs.CategoryManager.openDialog(true);
        },
        //打开人员选择器
        openUserPicker() {
            this.$refs.orgPicker.show(this.searchForm.receivers);
        },
        //人员选择回调
        selectedUser(data) {
            this.searchForm.receivers = data;
        },
        // 模糊搜索员工
        userSearch(queryString, cb) {
            // 防抖优化
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.$api.userSearch(queryString).then(res => {
                    if (res.code === 0) {
                        let userList = res.data
                        userList.forEach((item) => {
                            item.value = item.name
                        })
                        let results = queryString ? userList : [];
                        cb(results);
                    } else {
                        cb([]);
                    }
                });
            }, 500);
        },
        //获取字典数据
        getDictionaries(type) {
            if (type && this.dictionaries[type].length > 0) {              
                return
            }
            const params = { groupId: type }
            console.log(params, '获取字典数据');
            
            this.$api.dictionaries(params).then(res => {
                this.dictionaries[type] = res.data || []
            }).catch((err) => {
                console.log(err)
            })
        },
    }
}
</script>

<style scoped lang="scss">
.container {
    width: 100%;
    height: 100%;

    .content {
        width: 100%;
        min-height: calc(100vh - 118px);
        margin-top: 16px;
        background-color: white;
        padding-left: 16px;
        padding-right: 16px;
        box-sizing: border-box;
        padding-bottom: 16px;
        border-bottom: 32px solid #F5FAF9;
        border-radius: 8px 8px 8px 8px / 8px 8px 40px 40px;

        .search-form {
            padding-top: 32px;
        }

        .line {
            width: 100%;
            height: 1px;
            background: #EDF2F2;
            border-radius: 0px 0px 0px 0px;
            margin-top: 16px;
            clear: both;
        }

        .data-title {
            width: 100%;
            min-height: 32px;
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 12px;

            .title-line {
                width: 2px;
                height: 16px;
                background: #00B498;
                border-radius: 0px 0px 0px 0px;
                margin-top: 8px;
            }

            .title-name {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 16px;
                color: #2F3030;
                margin-left: 4px;
                line-height: 32px;
            }

            .title-btn {
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-end;
                gap: 12px;

                .title-btn-item {
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #E3E6E5;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 6px;
                    padding: 0 10px;
                    box-sizing: border-box;
                    cursor: pointer;
                    white-space: nowrap;

                    i, img { flex: none; }

                    .btn-l {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #2F3030;
                        white-space: nowrap;
                    }
                }


            }
        }

        /* 添加表格左对齐样式 */
        .left-aligned-table {
            ::v-deep .el-table th>.cell {
                text-align: left;
                justify-content: flex-start;
                color: #2F3030;
            }

            ::v-deep .el-table td>.cell {
                text-align: left;
            }

            ::v-deep .el-table .cell {
                text-align: left;
            }
        }

        .ellipsis2 {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            min-height: 34px; // 根据你的设计调整最小高度，确保至少显示两行
        }
    }

}
</style>

<style lang="scss">
// 审批状态圆形图标样式
.icon-act-status {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-top: 9px;
    margin-right: 4px;
}

.icon-act-status-1 {
    background: #F5C401;
    box-sizing: border-box;
}

.icon-act-status-2 {
    background: #00B498;
}

.icon-act-status-3 {
    background: #C5C9C9;
}

.icon-act-status-4 {
    background: #E23C58;
}

.icon-not-status-1 {
    background: #00B498;
    box-sizing: border-box;
}

.icon-not-status-2 {
    background: #C5C9C9;
}

.icon-not-status-3 {
    border: 1px solid #C5C9C9;
}
</style>
